import React from "react";
import "./FloatingTutorButton.css";

const FloatingTutorButton = () => {
  return (
    <button className="floating-tutor-button" style={{ cursor: "pointer" }}>
      <span className="tutor-button-text">
        <a
          href="mailto:learnjapanese.education@gmail.com?subject=Japanese%20Language%20Tutoring%20Request&body=Hello,%0A%0AI'm%20interested%20in%20Japanese%20language%20tutoring%20sessions.%0A%0ABest%20regards"
          target="_blank"
          rel="noreferrer"
        >
          FIND A TUTOR
        </a>
      </span>
      <div className="tutor-button-icon">
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M9 12l2 2 4-4"></path>
          <path d="M21 12c-1 0-2-1-2-2s1-2 2-2 2 1 2 2-1 2-2 2z"></path>
          <path d="M3 12c1 0 2-1 2-2s-1-2-2-2-2 1-2 2 1 2 2 2z"></path>
          <path d="M12 3c0 1-1 2-2 2s-2-1-2-2 1-2 2-2 2 1 2 2z"></path>
          <path d="M12 21c0-1 1-2 2-2s2 1 2 2-1 2-2 2-2-1-2-2z"></path>
        </svg>
      </div>
    </button>
  );
};

export default FloatingTutorButton;
